import request from '@/utils/request'
import { getCurrentShop } from "@/utils/vc"

/**
 * 查询管理员店铺列表
 * @param {Object} params 查询参数
 * @returns {Promise} 返回Promise对象
 */
export function queryShopsByAdmin(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shop.queryShopsByAdmin',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

export function getShopList(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shop.queryShop',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}


export function getDict(tableName,tableColumns) {
  return new Promise((resolve, reject) => {
      request({
          url: '/dict.listDict',
          method: 'get',
          params: {
            tableName: tableName,
            tableColumns: tableColumns,
              page:1,
              row:500
          }
      }).then(response => {
          const res = response.data
          // 获取验证码成功
          resolve(res)
      }).catch(error => {
          reject(error)
      })
  })
}
/**
 * 获取店铺类型列表
 * @param {Object} params 请求参数
 * @returns {Promise} Promise对象
 */
export function listShopTypes(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shopType.queryShopType',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

export function getCategoryList(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/productCategory.queryAdminProductCategory',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 获取地区数据
export function getAreas(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/area.listAreas',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}


export function saveShop(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shop.saveShop',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}
export function updateShop(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shop.updateShop',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

export function auditShop(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shop.auditShop',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}
// 获取商铺类型
export function getShopTypes(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shopType.queryShopType',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}


/**
 * 获取当前店铺ID
 * @returns {String} 店铺ID
 */
export function getShopId() {
  return getCurrentShop().shopId
}

/**
 * 获取当前店铺名称
 * @returns {String} 店铺名称
 */
export function getShopName() {
  return getCurrentShop().shopName
}

/**
 * 获取当前店铺信息
 * @returns {Object} 店铺信息对象
 */
export function getShop() {
  return getCurrentShop()
}

export function getAreaCode() {
  return getCurrentShop().areaCode
}